import { Chip } from '@heroui/react';

import {
  formatExecutionDuration,
  formatExecutionTime
} from './formatExecutionDuration';

import type { AgentExecutionDetail } from '~/api/agentLogs/types';
import i18n from '~/common/helpers/i18n';
import { CopyableText } from '~/components/CopyableText';

type AgentLogDetailsHeaderProps = {
  detail: AgentExecutionDetail;
};

export function AgentLogDetailsHeader({ detail }: AgentLogDetailsHeaderProps) {
  const duration = formatExecutionDuration(detail.startedAt, detail.finishedAt);
  const time = formatExecutionTime(detail.startedAt);

  return (
    <div
      className='flex flex-col gap-2 border-b border-outline px-2 py-4'
      data-testid='monitor-agent-logs-details-header'
    >
      <div className='flex flex-col gap-1'>
        <span className='text-label-md font-semibold uppercase tracking-wide text-on-surface'>
          {i18n.t('scenes.monitor.agentLogs.details.executionId')}
        </span>
        <div className='flex items-start justify-between gap-2'>
          <CopyableText
            text={detail.agentExecutionKey}
            className='min-w-0 flex-1 justify-start font-mono text-body-regular-md text-on-surface'
            data-testid='monitor-agent-logs-details-execution-key'
          >
            <span className='break-all'>{detail.agentExecutionKey}</span>
          </CopyableText>
        </div>
      </div>

      <div className='flex flex-wrap items-center gap-4 pt-2'>
        <div className='flex items-center gap-2'>
          <span className='text-label-md text-on-surface-variant'>
            {i18n.t('scenes.monitor.agentLogs.details.time')}
          </span>
          <Chip
            size='sm'
            className='bg-surface-dim text-label-md text-on-surface'
          >
            {time}
          </Chip>
        </div>
        <div className='flex items-center gap-2'>
          <span className='text-label-md text-on-surface-variant'>
            {i18n.t('scenes.monitor.agentLogs.details.duration')}
          </span>
          <Chip
            size='sm'
            className='bg-surface-dim text-label-md text-on-surface'
          >
            {duration}
          </Chip>
        </div>
      </div>
    </div>
  );
}
